<template>
  <div>
    <div v-for="(item) in adminPermissions" style="padding-bottom: 10px">
      <div style="border:1px solid #DDDFE6;padding-left: 10px">
        <el-checkbox v-model="item.checked" :indeterminate="item.indeterminate" false @change="handleCheckAllChange(item)">{{item.label}}</el-checkbox>
        <!--      <div style="margin-top: 10px"></div>-->
        <br/>
        <el-checkbox v-for="subItem in item.subMenus" :label="subItem.label" :key="subItem.label" v-model="subItem.checked" @change="handleCheckItemChange(item)">{{subItem.label}}</el-checkbox>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'UserPremissionsComponent',
  data () {
    return {
      adminPermissions: [
        {label: '用户管理', checked: false, indeterminate: true, subMenus:
          [{label: '老师', path: 'teacherop', checked: false},
            {label: '助教', path: 'assistantop', checked: false},
            {label: '学生', path: 'studentop', checked: false}]
        },
        {label: '课程直播管理', checked: false, indeterminate: false, subMenus:
            [{label: '课程管理', path: 'courseop', checked: false},
              {label: '直播管理', path: 'liveop', checked: false}]
        },
        {label: '云盘管理', checked: true, indeterminate: false, subMenus:
            [{label: '机构云盘', path: 'clouddiskop', checked: true}]
        },
        {label: '消息通知', checked: false, indeterminate: false, subMenus:
            [{label: '消息管理', path: 'messageop', checked: false}]
        }],
      teacherPermissions: [
        {label: '云盘管理', checked: false, indeterminate: true, subMenus:
            [{label: '机构云盘（只读）', path: 'clouddiskop', checked: false},
              {label: '老师云盘', path: 'teaclouddiskop', checked: true}]
        }
      ]
    }
  },
  methods: {
    handleCheckAllChange (item) {
      console.log(item)
      if (item.indeterminate === true) {
        item.indeterminate = false
        item.checked = true
      }
      // debugger
      for (let i = 0; i < item.subMenus.length; i++) {
        let subItem = item.subMenus[i]
        subItem.checked = item.checked
      }
    },
    handleCheckItemChange (item) {
      let itemCheckedCount = 0
      for (let i = 0; i < item.subMenus.length; i++) {
        let subItem = item.subMenus[i]
        if (subItem.checked === true) {
          itemCheckedCount++
        }
      }
      if (itemCheckedCount === 0) {
        item.checked = false
        item.indeterminate = false
      } else if (itemCheckedCount === item.subMenus.length) {
        item.checked = true
        item.indeterminate = false
      } else {
        item.checked = false
        item.indeterminate = true
      }
    },
    getCurPremissions () {
      let resArray = []
      for (let i = 0; i < this.adminPermissions.length; i++) {
        let item = this.adminPermissions[i]
        let itemCheckedCount = 0
        let itemArray = []
        for (let j = 0; j < item.subMenus.length; j++) {
          let subItem = item.subMenus[j]
          if (subItem.checked === true) {
            itemCheckedCount++
            let resSubItem = {label: subItem.label, path: subItem.path}
            itemArray.push(resSubItem)
          }
        }
        if (itemCheckedCount > 0) {
          let label = item.label
          if (label === '课程直播管理') {
            label = '课程直播'
          }
          let resItem = {label: label, subMenus: itemArray}
          resArray.push(resItem)
        }
      }
      return resArray
    },
    setIsTeacher (isTea) {
      if (isTea) {
        this.adminPermissions = this.teacherPermissions
      }
    },
    setCurPremissions (preArray) {
      for (let i = 0; i < this.adminPermissions.length; i++) {
        let item = this.adminPermissions[i]
        let itemCheckedCount = 0
        for (let j = 0; j < item.subMenus.length; j++) {
          let subItem = item.subMenus[j]
          let hasItem = this.hasSubMenuByLabel(preArray, subItem.label)
          if (hasItem) {
            subItem.checked = true
            itemCheckedCount++
          } else {
            subItem.checked = false
          }
        }
        if (itemCheckedCount === 0) {
          item.checked = false
          item.indeterminate = false
        } else if (itemCheckedCount === item.subMenus.length) {
          item.checked = true
          item.indeterminate = false
        } else {
          item.checked = false
          item.indeterminate = true
        }
      }
    },
    hasSubMenuByLabel (preArray, label) {
      for (let i = 0; i < preArray.length; i++) {
        let item = preArray[i]
        for (let j = 0; j < item.subMenus.length; j++) {
          let subItem = item.subMenus[j]
          if (subItem.label === label) {
            return true
          }
        }
      }
      return false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/UserPremissionsComponent.vue